import React from "react";

//import Subheader from "./Subheader";
import BarChart from "../BarChart";
import { getColor } from "../../tools";
import EmptyBoard from "./EmptyBoard";
import PieChart from "../PieChart";

function QuantitativeBoard({
  data,
  table,
  selectedLabels,
  quantitativeLabelsChecked,
  labelOpacity,
  setLabelOpacity,
  thumbnail,
  error,
  showValues,
  verticalBars,
  pieChart,
  sortDec,
}) {
  const quantAnalysis = window.quantAnalysis;

  const analyses = quantitativeLabelsChecked.map((quantitativeLabel) => {
    const values = data
      .flatMap((beep) =>
        beep.table.filter((row) => row.id === quantitativeLabel.id)
      )
      .map(({ score }) => score);
    return {
      ...quantAnalysis(values, [0, 100]),
      id: quantitativeLabel.id,
      label: quantitativeLabel.label,
      NM: values.length,
    };
  });
  console.log(analyses);
  const barchart = analyses.flatMap((analyse) => {
    let dataObj = {};

    dataObj["name"] = analyse.label;

    let value = Math.round((analyse.M + Number.EPSILON) * 100) / 100;

    const errorMin = !isNaN(analyse.DELTAPLOW) ? analyse.DELTAPLOW * 100 : 0;
    const errorMax = !isNaN(analyse.DELTAPUP) ? analyse.DELTAPUP * 100 : 0;
    const error = [errorMin, errorMax];

    dataObj["quantitativeLabel"] = value;
    dataObj["quantitativeLabel$label"] = analyse.label;
    dataObj["quantitativeLabel$error"] = error;
    dataObj["quantitativeLabel$numberOfMeasurements"] = analyse.NM;
    dataObj["quantitativeLabel$color"] = getColor(analyse.id);
    return dataObj;
  });
  //console.log(barchart);
  return (
    <React.Fragment>
      {pieChart ? (
        <PieChart
          data={barchart}
          quantitativeLabelsChecked={[{ id: "quantitativeLabel", label: "" }]}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          showValues={showValues}
          sortDec={sortDec}
        />
      ) : (
        <BarChart
          data={barchart}
          quantitativeLabelsChecked={[{ id: "quantitativeLabel", label: "" }]}
          opacity={labelOpacity}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          error={error}
          showValues={showValues}
          verticalBars={verticalBars}
          sortDec={sortDec}
        />
      )}
    </React.Fragment>
  );
}

export default QuantitativeBoard;
